export const SET_AREAS = "AREAS/SET_AREAS";
export const SET_AREA = "AREAS/SET_AREA";
export const SET_PAGINATION = "AREAS/SET_PAGINATION";
